
import React, { useState, useEffect ,Component,} from 'react';
import './hojaestilotitulacion.css'; // Asegúrate de importar este archivo


const MensajeTipoTitulacion = ({ tipo }) => {
  return (
    <div className="titulo-card-container">
      <div className="titulo-card animated-card">
        <div className="icono-container">
          <svg className="icono-bounce" xmlns="http://www.w3.org/2000/svg" width="40" height="40" fill="rgb(142, 192, 72)" viewBox="0 0 16 16">
            <path d="M10.854 6.146a.5.5 0 0 0-.708 0L7 9.293 5.854 8.146a.5.5 0 1 0-.708.708l1.5 1.5a.5.5 0 0 0 .708 0l3.5-3.5a.5.5 0 0 0 0-.708z"/>
            <path d="M14 4.5V14a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h5.5L14 4.5zm-3-.5a1 1 0 0 1-1-1V1H4a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V4h-2z"/>
          </svg>
        </div>
        <h3 className="titulo-card-header">Tipo de Titulación Seleccionado</h3>
        <p className="titulo-card-body">
          Usted ha seleccionado el tipo de titulación:
          <span className="titulo-card-highlight"> {tipo}</span>
        </p>
        <p className="titulo-card-footer">
 
        </p>
      </div>
    </div>
  );
};

export default MensajeTipoTitulacion;